import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=ecf3321e&scoped=true&"
import script from "./Request.vue?vue&type=script&lang=js&"
export * from "./Request.vue?vue&type=script&lang=js&"
import style0 from "./Request.vue?vue&type=style&index=0&id=ecf3321e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf3321e",
  null
  
)

export default component.exports